import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ImageResource } from './image-resource.model';
import { ImageResourceService } from './image-resource.service';
@Injectable()
export class ImageResourcePopupService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private imageResourceService: ImageResourceService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.imageResourceService.find(id).subscribe(imageResource => {
                this.imageResourceModalRef(component, imageResource);
            });
        } else {
            return this.imageResourceModalRef(component, new ImageResource());
        }
    }

    imageResourceModalRef(component: Component, imageResource: ImageResource): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.imageResource = imageResource;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource-popup.service.ts